const META_ID = process.env.REACT_APP_META_PIXEL_ID;
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

let initialized = false;

function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const script = document.createElement("script");
    script.id = id;
    script.async = true;
    script.src = src;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

function initMeta() {
  if (!META_ID) return Promise.resolve(false);
  if (!window.fbq) {
    const fbq = function (...args) {
      fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;
  }
  return loadScript("https://connect.facebook.net/en_US/fbevents.js", "meta-pixel-script")
    .then(() => {
      window.fbq("init", META_ID);
      return true;
    })
    .catch(() => false);
}

function initGA() {
  if (!GA_ID) return Promise.resolve(false);
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function (...args) {
      window.dataLayer.push(args);
    };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  return loadScript(
    `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`,
    "ga4-script"
  )
    .then(() => true)
    .catch(() => false);
}

export function initAnalytics() {
  if (initialized) return;
  initialized = true;
  Promise.allSettled([initMeta(), initGA()]).then(() => {
    if (META_ID && window.fbq) window.fbq("track", "PageView");
    if (GA_ID && window.gtag) {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
      });
    }
  });
}

export function trackWhatsAppClick(ctaName) {
  if (META_ID && window.fbq) {
    window.fbq("track", "Lead", { content_name: ctaName });
  }
  if (GA_ID && window.gtag) {
    window.gtag("event", "whatsapp_cta_click", { cta_name: ctaName, destination: "whatsapp" });
  }
}

export function trackQuestionnaireSubmit(area) {
  if (META_ID && window.fbq) {
    window.fbq("track", "Lead", { content_name: "questionnaire_submit" });
  }
  if (GA_ID && window.gtag) {
    window.gtag("event", "questionnaire_submit", { area });
  }
}

export function trackMappaClick(ctaName) {
  if (META_ID && window.fbq) {
    window.fbq("track", "Lead", { content_name: ctaName });
  }
  if (GA_ID && window.gtag) {
    window.gtag("event", "mappa_cta_click", { cta_name: ctaName });
  }
}
